import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logPostInfo, logging } from '../../actions/log';
import { CONTEXT } from '../../config';
import { getSearchRecommend } from '../../actions/search';
import Button from '../Button/Button';
import Rate from '../Rate/Rate';
import styles from './LineCard.module.less';
import { setIframeVisible } from '../../actions/layout';
import DEFAULTIMG from '../../static/default.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ soft, logInfo, info, softIndex }) => {
  const dispatch = useDispatch();
  const installedSoftInit = useSelector(selectInstalledSoft);
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftBtn = useCallback(
    _soft => {
      const found = installedSoftInit.find(
        soft_ => soft_.softID === _soft.softID || soft_.SoftID === _soft.softID,
      );
      if (!found) {
        dispatch(
          getSearchRecommend({
            softInfo: _soft.softID,
            androidType: _soft.androidType || 0,
            soruce: 'search',
          }),
        );
      }
    },
    [dispatch, installedSoftInit],
  );

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'LineCard_err';
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
        // bizInfo: soft_.bizInfo
      }),
    );
  }, [dispatch]);

  const handleShopping = url => () => {
    dispatch(
      setIframeVisible({
        visible: true,
        url,
        source: logInfo ? logInfo.source : 'LineCard_err',
      }),
    );
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Buy_Text',
        label: '',
        param2: {
          source: logInfo ? logInfo.source : 'LineCard_err',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          softid: soft.softID,
          softType: soft.androidType || 0,
          id: soft.merchandiseMap.sid,
          // id 商品id
          // softtype
        },
        param3: soft && soft.bizInfo,
      }),
    );
  };
  // 搜索结果页-商品活动文字链展现
  useEffect(() => {
    if (soft && soft.merchandiseMap && soft.merchandiseMap.merchandiseUrl) {
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Buy_Text',
          label: '',
          param2: {
            source: logInfo ? logInfo.source : 'LineCard_err',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word,
            softId: soft.softID,
            softType: soft.androidType || 0,
            id: soft.merchandiseMap.sid,
            // id 商品id
            // softtype
          },
          param3: soft && soft.bizInfo,
        }),
      );
    }
  }, []);

  return (
    <div className={`${styles.card} ${softIndex === 0 ? styles.card_first : ''}`}>
      <div className={styles.card_main}>
        <div className="app">
          <Link
            to={`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`}
            onClick={() => {
              handleSoftCard(soft);
            }}
          >
            <div className="app_img_container">
              <img className="app_img" src={soft.logoFile || DEFAULTIMG} alt="" />
            </div>
          </Link>
          <div className="info">
            <div className="title_info">
              <Link
                className="title"
                to={`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`}
                onClick={() => {
                  handleSoftCard(soft);
                }}
                title={soft.softName}
              >
                {soft.softName}
              </Link>
              {soft &&
                soft.searchTag &&
                soft.searchTag.map((item, i) => (
                  <img
                    className="table"
                    src={item.icon}
                    key={i}
                    alt={item.name || ''}
                    title={item.tips || ''}
                  />
                ))}
            </div>
            <Link
              className="desc"
              to={`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`}
              onClick={() => {
                handleSoftCard(soft);
              }}
              title={soft.introduction}
            >
              {soft.introduction}
            </Link>
          </div>
          <Link
            className="size"
            to={`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`}
            onClick={() => {
              handleSoftCard(soft);
            }}
          >
            {soft.installFileSize}
          </Link>
          <div className="score">
            <Rate score={(Number(soft.score) / 20).toFixed(1)} />
            <span className="val">{(Number(soft.score) / 20).toFixed(1)}</span>
          </div>
        </div>

        <div className="opt">
          <div
            className="opt_div"
            onClick={() => {
              handleSoftBtn(soft);
            }}
          >
            <Button
              soft={soft}
              info={{
                ...info,
                className: styles.soft_btn,
                className_busing: styles.soft_btn_b,
                className_open: styles.soft_button_open,
              }}
              logInfo={logInfo}
            />
          </div>
        </div>
      </div>
      {soft.merchandiseMap && (
        <>
          <div className="ad" onClick={handleShopping(soft.merchandiseMap.merchandiseUrl)}>
            {soft.merchandiseMap.desc}
          </div>
          <div className="ad_arrow">&gt;</div>
        </>
      )}
    </div>
  );
});
